{
  "name": "@ns/public-ledger-auto-payments-change-amounts",
  "version": "1.0.0",
  "description": "Change the company's automatic payments amounts (#25 phase 6). Held by the signatory who started it (from My Account, or a Limit reached, Change target or Raise operating target card); any public ledger signatory can claim it if it is released. SOURCE says where it was started (ACCOUNT, LIMIT_REACHED, CHANGE_TARGET, RAISE_TARGET) and FOCUS which amounts brought them here (LIMIT, TARGET, OPERATING_TARGET or none); from a Limit reached card, LIMIT says which limit was reached (CARD or OPERATING), whose field is focused first. The holder chooses the new thresholds, targets, limits and price alert, which public-ledger/autopay/propose-change checks at today's price and records; it then completes the card proposed (server), and the workflow schedules the approval for every signatory to sign. cancel ends the change; unchanged (the holder pressed Complete twice with nothing changed) ends it with no proposal and no signatures.",
  "inputs": {},
  "outcomes": {
    "proposed": {
      "serverOnly": true
    },
    "cancel": {},
    "unchanged": {}
  }
}
